// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\AvailabilityComputeResponse

import { hydrateOffer, type Offer, type OfferApiResponse } from './offer.gen';

export type AvailabilityComputeApiResponse = {
	avails: Array<{ part: string; diff: Array<{ title: string; rows: Array<Array<string>> }> }>;
	sessions: Array<{ id: string; name: string; duration: number | null; openingTimes: Array<{ start: number; end: number; startText: string; endText: string }>; eventDates: Array<{ date: string; start: number; end: number; startText: string; endText: string }> }>;
	areas: Array<{ id: string; name: string; openingTimes: Array<{ start: number; end: number; startText: string; endText: string }> }>;
	offer: OfferApiResponse | null;
};

export type AvailabilityCompute = {
	avails: Array<{ part: string; diff: Array<{ title: string; rows: Array<Array<string>> }> }>;
	sessions: Array<{ id: string; name: string; duration: number | null; openingTimes: Array<{ start: number; end: number; startText: string; endText: string }>; eventDates: Array<{ date: string; start: number; end: number; startText: string; endText: string }> }>;
	areas: Array<{ id: string; name: string; openingTimes: Array<{ start: number; end: number; startText: string; endText: string }> }>;
	offer: Offer | null;
};

export function hydrateAvailabilityCompute(data: AvailabilityComputeApiResponse): AvailabilityCompute {
	return {
		...data,
		offer: data.offer ? hydrateOffer(data.offer) : null,
	};
}